import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Txt from '../../../inputs/textInput.js';

export default function CenterPanelEditPortalSetting(props) {
  const selectedPortalSettingValue = useSelector((state) => state.portalSettingReducer.selectedPortalSettingValue);

  const handleEditValue = (value) => {
    props.setLatestValueSaveChange(value);
  };
  useEffect(() => {
    props.setResetButtonTriggerValueChange(false);
    if (!props.resetButtonTriggerValueChange) {
      props.setLatestValueSaveChange(selectedPortalSettingValue?.currentValue);
    } else {
      props.setLatestValueSaveChange(selectedPortalSettingValue?.defaultValue);
    }
  }, []);

  return (
    <div className="ui form mrbs">
      <div className="placeholder-label color-placeholder">
        {APP.LANGUAGE.WaitingAreaManageUsers.ColumnHeader1Title}
      </div>
      <div className="title-sms mrbm">{selectedPortalSettingValue.name}</div>
      <div className="mrtl">
        <div className="placeholder-label color-placeholder">
          {APP.LANGUAGE.WaitingAreaManageTags.ColumnHeader2Title}
        </div>
        <Txt
          textArea
          rows="13"
          focusme="true"
          classes="textarea minHeightTextareaMedium"
          tabIndex="1"
          value={props.latestValueSaveChange}
          onChange={handleEditValue}
          fieldClasses="ui htxl input textarea mrtnull"
          titlePlaceholder={APP.LANGUAGE.AdminMenu.PortalTextValue}
        />
      </div>
    </div>
  );
}
